export default __webpack_public_path__ + "static/media/VerifyAccount.6c8a3665.svg";